import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site-shell";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact DealDraft" },
      {
        name: "description",
        content: "Get in touch with the DealDraft team by email.",
      },
    ],
    links: [{ rel: "canonical", href: "https://dealdraft.pro/contact" }],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <SiteShell>
      <article className="mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Contact DealDraft</h1>

        <div className="mt-8 space-y-6 text-base leading-relaxed text-muted-foreground">
          <p>
            <a
              href="mailto:support@dealdraft.pro"
              className="text-xl font-medium text-foreground underline hover:no-underline"
            >
              support@dealdraft.pro
            </a>
          </p>

          <p>
            Reach out for support, billing questions, feedback, or press inquiries — we read
            every message.
          </p>

          <p>DealDraft is operated by LJ Legacy Solutions LLC, Kansas, USA.</p>
        </div>
      </article>
    </SiteShell>
  );
}
